export default "__VITE_ASSET__DKf0xnVr__"